package com.sddamico.draftmachine.models

import kotlinx.serialization.Serializable

@Serializable
data class VapidKeyResponse(val publicKey: String)

@Serializable
data class PushSubscribeRequest(
  val endpoint: String,
  val p256dh: String,
  val auth: String,
)

/**
 * Optional description of the calling browser's own subscription. Sent so the server can answer
 * "is *this* browser wired up?" without ever handing back another device's endpoint — a push
 * endpoint is a capability URL, so it stays server-side.
 */
@Serializable
data class PushStatusRequest(
  val endpoint: String? = null,
  val p256dh: String? = null,
  val auth: String? = null,
)

/** One of the caller's registered browsers, identified by provider rather than by endpoint. */
@Serializable
data class PushSubscriptionSummary(
  val provider: String,
  val registeredAt: String,
  val updatedAt: String,
  val isThisBrowser: Boolean,
)

/** Verdict on the endpoint the caller sent in [PushStatusRequest]. */
@Serializable
data class PushBrowserStatus(
  val registered: Boolean,
  /** Stored keys match the ones this browser just reported (false ⇒ the row is stale). */
  val keysMatch: Boolean,
  /** The endpoint is registered, but to a different account on this browser. */
  val ownedByAnotherAccount: Boolean,
)

@Serializable
data class PushStatusResponse(
  /** The server has VAPID keys and can actually deliver. */
  val configured: Boolean,
  val publicKey: String? = null,
  val subscriptions: List<PushSubscriptionSummary> = emptyList(),
  val thisBrowser: PushBrowserStatus? = null,
)

@Serializable
data class PushTestResponse(
  val attempted: Int,
  val delivered: Int,
  val failures: List<PushTestFailure> = emptyList(),
)

@Serializable
data class PushTestFailure(
  val provider: String,
  val detail: String,
  /** The provider reported the endpoint as gone, so the stale subscription was dropped. */
  val removed: Boolean,
)
